import { useState, useEffect } from 'react';

export const useFreeConsultationOffer = (delayMs = 1200) => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const hasUsedOffer = localStorage.getItem("has_used_first_offer") === "true";
    const alreadyShown = sessionStorage.getItem("free_popup_shown") === "true";

    if (!hasUsedOffer && !alreadyShown) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        sessionStorage.setItem("free_popup_shown", "true");
      }, delayMs);

      return () => clearTimeout(timer);
    }
  }, [delayMs]);

  return {
    showPopup,
    closePopup: () => setShowPopup(false),
  };
};